<template>
  <div>
    <div class="bg-gray">
      <div class="banner_bg">
        <img
            src="~@/assets/images/mainindex/qcxj-club.jpeg"
            class="banner_bg_pic"
        />
        <div>
          <div class="banner_bg_desc">
            <div class="banner_bg_desc_title">啦啦操星级俱乐部</div>
            <div class="banner_bg_desc_entitle">CCA Club</div>
          </div>
          <div class="banner_bg_desc">
            <div class="banner_bg_desc_title">啦啦操七彩星级</div>
            <div class="banner_bg_desc_entitle">Cheerleading Rainbow Stars</div>
          </div>
        </div>
      </div>
      <special-tabs class="special-box" :activeName="activeName" :tabList="tabList" @onClick="onClick"></special-tabs>
      <special-tabs class="special-box mt20" :activeName="activeSecondName" :tabList="tabListSecond"
                    @onClick="onClickSecond"></special-tabs>


      <div class="container-content container-wrap">
        <el-form v-if="activeName != '政策解读' && activeName != '宣传文件' && activeSecondName !='风采展示' && activeSecondName !='七彩文化区'" :inline="true" :model="params" class="demo-form-inline">
          <el-form-item label="关键字" v-if="activeSecondName == '星级俱乐部' || activeSecondName == '大课间推广实施单位及先进个人' || activeSecondName == '考级中心(点)'">
            <el-input v-model="params.keywords" placeholder="请输入关键字"></el-input>
          </el-form-item>
          <el-form-item label="关键字" v-if="activeSecondName == '四好运动员' || activeSecondName == '七彩星级等级运动员'">
            <el-input v-model="params.keywords" placeholder="请输入姓名或身份证号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button type="primary" class="mb10" @click="toApply"
                       v-if="activeName != '政策解读' && activeName != '宣传文件' && activeSecondName !='风采展示' && activeSecondName !='七彩文化区'">
              申报入口
            </el-button>

          </el-form-item>
        </el-form>


        <div
            v-if="activeSecondName == '星级俱乐部' || activeSecondName == '四好运动员' ||activeSecondName == '大课间推广实施单位及先进个人' ||activeSecondName == '考级中心(点)' || activeSecondName == '七彩星级等级运动员'"
            class="organization_content">
          <div class="header_screen">
            <div class="header_screen_item">
              <div class="header_screen_item_title">省份：</div>
              <div class="header_screen_item_content">
                <div
                    class="header_screen_item_el" :class="params.namekey == 0 ? 'header_screen_item_el_active' : 0"
                    @click="onSelectArea(0)">全部
                </div>
                <div
                    class="header_screen_item_el"
                    v-for="(item, index) in areaList"
                    :key="index"
                    :class="params.namekey == item.key ? 'header_screen_item_el_active' : 0"
                    @click="onSelectArea(item.key)"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>


            <div class="header_screen_item">
              <div class="header_screen_item_title">类型：</div>
              <div class="header_screen_item_content">

                <div
                    class="header_screen_item_el"
                    v-for="(item, index) in typeData"
                    :key="index"
                    :class="params.area_type == item.key ? 'header_screen_item_el_active' : 0"
                    @click="onSelectType(item.key)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="header_screen_item"></div>
          </div>

          <!-- 列表数据内容 -->
          <div class="organization_content_list"  v-loading="loading">
            <div v-if="activeSecondName == '星级俱乐部'" class="organization_content_list_item"
                 v-for="(item,index) in list" :key="index">
              <div class="organization_content_list_item_left">
                <el-image
                    :src="item.pic_url"
                    :preview-src-list="[item.pic_url]">
                </el-image>
              </div>
              <div class="organization_content_list_item_desc">
                <div class="organization_content_list_item_title show-one-row">{{ item.danwei }}</div>
                <!--                <div class="organization_content_list_item_desc_title">-->
                <!--                  {{ item.area_type == 1 ? item.province : item.city }}推广负责人-->
                <!--                </div>-->
                <div class="organization_content_list_item_desc_contacts show-one-row">
                  {{ item.province }}{{ item.city }}{{ item.county }}<span v-if="item.bgrade">({{item.bgrade}})</span>
                </div>
                <div class="organization_content_list_item_desc_contacts" v-if="item.nickname">
                  负责人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span >{{ item.nickname }}({{item.phone}})</span>
                </div>
                <div class="organization_content_list_item_desc_contacts" v-if="item.contactsname">
                  联系人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span  >{{ item.contactsname }}({{item.contactsphone}})</span>
                </div>
              </div>
              <div class="organization_content_list_item_tag_province" v-if="item.clubleixing == '社会俱乐部'">{{
                  item.clubleixing
                }}
              </div>
              <div class="organization_content_list_item_tag" v-else>{{ item.clubleixing }}</div>
            </div>

            <div v-if="activeSecondName == '四好运动员'" class="organization_content_list_item"
                 v-for="(item,index) in list" :key="index">
              <div class="organization_content_list_item_left" v-if="item.pic_url">
                <el-image
                    :src="item.pic_url"
                    :preview-src-list="[item.pic_url]">
                </el-image>
              </div>
              <div class="organization_content_list_item_desc">
                <div class="organization_content_list_item_nopic_title show-one-row">{{ item.danwei }}</div>
                <!--                <div class="organization_content_list_item_desc_title">-->
                <!--                  {{ item.area_type == 1 ? item.province : item.city }}推广负责人-->
                <!--                </div>-->
                <div class="organization_content_list_item_desc_contacts show-one-row">
                  {{ item.province }}{{ item.city }}{{ item.county }}<span v-if="item.bgrade">({{item.bgrade}})</span>
                </div>
                <div class="organization_content_list_item_desc_contacts" v-if="item.name">
                  姓名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span >{{ item.name }}</span>
                </div>
                <div class="organization_content_list_item_desc_contacts" v-if="item.xueduan">
                  学段&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span  >{{ item.xueduan}}</span>
                </div>
              </div>
<!--              <div class="organization_content_list_item_tag_province" v-if="item.clubleixing == '社会俱乐部'">{{-->
<!--                  item.clubleixing-->
<!--                }}-->
<!--              </div>-->
<!--              <div class="organization_content_list_item_tag" v-else>{{ item.clubleixing }}</div>-->
            </div>

            <div v-if="activeSecondName == '大课间推广实施单位及先进个人'" class="organization_content_list_item"
                 v-for="(item,index) in list" :key="index">
              <div class="organization_content_list_item_left">
                <!--              <img src="../../assets/images/mainindex/organization-banner@2x.png" alt="">-->
                <!--              <img :src="item.wechat_pic_url" alt="">-->
                <!--                <el-image-->
                <!--                    :src="item.wechat_pic_url"-->
                <!--                    :preview-src-list="[item.wechat_pic_url]">-->
                <!--                </el-image>-->
                <!--                <div class="organization_content_list_item_tip">加我企业微信</div>-->
              </div>
              <div class="organization_content_list_item_desc">
                <div class="organization_content_list_item_nopic_title">{{ item.danwei }}</div>
                <!--                <div class="organization_content_list_item_desc_title">-->
                <!--                  {{ item.area_type == 1 ? item.province : item.city }}推广负责人-->
                <!--                </div>-->
                <div class="organization_content_list_item_desc_contacts show-one-row">
                  {{ item.province }}{{ item.city }}{{ item.county }}
                </div>
                <div class="organization_content_list_item_desc_contacts" v-if="item.name">
                  联系人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span  >{{ item.name }}({{item.phone}})</span>
                </div>
              </div>
<!--              <div class="organization_content_list_item_tag_province" v-if="item.kaojitype == '考级中心'">{{-->
<!--                  item.kaojitype-->
<!--                }}-->
<!--              </div>-->
<!--              <div class="organization_content_list_item_tag" v-else>{{ item.kaojitype }}</div>-->
            </div>

            <div v-if="activeSecondName == '考级中心(点)'" class="organization_content_list_item"
                 v-for="(item,index) in list" :key="index">
              <div class="organization_content_list_item_left">
                <!--              <img src="../../assets/images/mainindex/organization-banner@2x.png" alt="">-->
                <!--              <img :src="item.wechat_pic_url" alt="">-->
                <!--                <el-image-->
                <!--                    :src="item.wechat_pic_url"-->
                <!--                    :preview-src-list="[item.wechat_pic_url]">-->
                <!--                </el-image>-->
                <!--                <div class="organization_content_list_item_tip">加我企业微信</div>-->
              </div>
              <div class="organization_content_list_item_desc">
                <div class="organization_content_list_item_nopic_title">{{ item.danwei }}</div>
                <!--                <div class="organization_content_list_item_desc_title">-->
                <!--                  {{ item.area_type == 1 ? item.province : item.city }}推广负责人-->
                <!--                </div>-->
                <div class="organization_content_list_item_desc_contacts show-one-row">
                  {{ item.province }}{{ item.city }}{{ item.county }}
                </div>
                <div class="organization_content_list_item_desc_contacts">
                  考官&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span v-for="member in item.kaoguan"
                                                        style="margin-right: 4px">{{ member.name }}</span>
                </div>
                <div class="organization_content_list_item_desc_contacts">
                  监督&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span v-for="member in item.jiandu"
                                                        style="margin-right: 4px">{{ member.name }}</span>
                </div>
              </div>
              <div class="organization_content_list_item_tag_province" v-if="item.kaojitype == '考级中心'">{{
                  item.kaojitype
                }}
              </div>
              <div class="organization_content_list_item_tag" v-else>{{ item.kaojitype }}</div>
            </div>


            <div v-if="activeSecondName == '七彩星级等级运动员'" class="organization_content_list_item"
                 v-for="(item,index) in list" :key="index">
              <div class="organization_content_list_item_left">
                <!--              <img src="../../assets/images/mainindex/organization-banner@2x.png" alt="">-->
                <!--              <img :src="item.wechat_pic_url" alt="">-->
                <!--                <el-image-->
                <!--                    :src="item.wechat_pic_url"-->
                <!--                    :preview-src-list="[item.wechat_pic_url]">-->
                <!--                </el-image>-->
                <!--                <div class="organization_content_list_item_tip">加我企业微信</div>-->
              </div>
              <div class="organization_content_list_item_desc">
                <div class="organization_content_list_item_nopic_title">{{ item.danwei }}</div>
                <!--                <div class="organization_content_list_item_desc_title">-->
                <!--                  {{ item.area_type == 1 ? item.province : item.city }}推广负责人-->
                <!--                </div>-->
                <div class="organization_content_list_item_desc_contacts show-one-row">
                  {{ item.province }}{{ item.city }}{{ item.county }}
                </div>
                <div class="organization_content_list_item_desc_contacts" v-if="item.name">
                  姓名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span  >{{ item.name }}</span>
                </div>
                <div class="organization_content_list_item_desc_contacts" v-if="item.grade">
                  等级&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span  >{{ item.grade }}</span>
                </div>
              </div>
              <!--              <div class="organization_content_list_item_tag_province" v-if="item.kaojitype == '考级中心'">{{-->
              <!--                  item.kaojitype-->
              <!--                }}-->
              <!--              </div>-->
              <!--              <div class="organization_content_list_item_tag" v-else>{{ item.kaojitype }}</div>-->
            </div>

            <el-pagination
                v-if="row.totalpage > 1"
                style="padding-bottom: 20px;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="row.p"
                :page-size="row.step"
                background
                layout="total, prev, pager, next"
                :total="row.total"
            >
            </el-pagination>
          </div>


        </div>

        <div v-else>
          <div v-if="list.length > 0" v-for="item in list" class="contactus_content_li" :key="item.id">
            <NewsItem :row="item"></NewsItem>
          </div>

          <el-pagination
              v-if="row.totalpage > 1 && !loading"
              style="padding-bottom: 20px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="row.p"
              :page-size="row.step"
              background
              layout="total, prev, pager, next"
              :total="row.total"
          >
          </el-pagination>
        </div>


        <div v-if="list.length === 0 && !loading" class="mt20">
          没有更多数据了～
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import SpecialTabs from "@/components/mainindex/SpecialTabs";
import NewsItem from "@/components/mainindex/NewsItem";

export default {
  name: "QcxjClub",
  data() {
    return {
      videoAction: false,
      loading: true,
      activeName: '啦啦操星级俱乐部',
      activeSecondName: '星级俱乐部',
      tabList: [
        {name: "啦啦操星级俱乐部", class: "tabs-item-active"},
        {name: "啦啦操七彩星级", class: ""},
        {name: "政策解读", class: ""},
        {name: "宣传文件", class: ""},
      ],
      tabListSecond: [],
      tabListSecondClub: [
        {name: "星级俱乐部", class: ""},
        {name: "四好运动员", class: ""},
        {name: "大课间推广实施单位及先进个人", class: ""},
      ],
      tabListSecondQcxj: [
        {name: "考级中心(点)", class: ""},
        {name: "七彩星级等级运动员", class: ""},
        {name: "七彩文化区", class: ""},
        {name: "风采展示", class: ""},
      ],
      typeData: [
        {name: "全部", class: "header_screen_item_el_active", key: 0},
        {name: "省级", class: "", key: 1},
        {name: "市级", class: "", key: 2},
      ],
      areaList: [],

      params: {
        keywords: '',
        pageNo: 1,
        pageSize: 9,
        cate_id: 10,
        namekey: 0,
        area_type: 0,
      },

      row: {},
      list: []
    };
  },
  mounted() {
    document.title = "俱乐部七彩星级"
    this.getAreaList()
    this.getData()
    this.getSecondTabs()

  },
  components: {
    SpecialTabs, NewsItem
  },
  watch: {
    // 点击tab 触发获取数据方法
    activeSecondName(val) {
      console.log('val', val)
      let activeName = this.activeName
      if(activeName !='政策解读' && activeName != '宣传文件') {

      }
      if (val == '星级俱乐部' || val == '四好运动员' || val == '七彩星级等级运动员' || val == '考级中心(点)' || val == '大课间推广实施单位及先进个人') {
        // 获取考级中心(点) 数据
        this.getAreaList()
        this.getData()
      } else if (2) {

      }
    }
  },
  methods: {
    //获取风采资讯
    fetch() {
      const that = this;
      that.$api.get(
          "/api/cms/cmslist",
          that.params,
          res => {
            that.loading = false;

            res.data.p = parseInt(res.data.p)
            res.data.step = parseInt(res.data.step)
            res.data.total = parseInt(res.data.total)
            that.row = res.data
            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.list = res.data.list;
            } else {
              that.list = that.list.concat(res.data.list);
            }
            if (res.data.list.length == 0) {
              that.finished = true;
            }

            that.params.pageNo += 1;
          },
          res => {
            that.$message.error(res.msg);
          }
      );
    },

    getAreaList() {
      let that = this
      that.$api.get(
          "/api/utils/areaProvinceList",
          {},
          res => {
            that.areaList = res.data
          },
          res => {
            that.$message.error(res.msg);
          }
      );
    },

    getKaojiList() {
      const that = this;

      that.$api.get(
          "/api/cms/cmslist",
          that.params,
          res => {
            that.loading = false;

            res.data.p = parseInt(res.data.p)
            res.data.step = parseInt(res.data.step)
            res.data.total = parseInt(res.data.total)
            that.row = res.data
            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.list = res.data.list;
            } else {
              that.list = that.list.concat(res.data.list);
            }
            if (res.data.list.length == 0) {
              that.finished = true;
            }

            that.params.pageNo += 1;
          },
          res => {
            that.$message.error(res.msg);
          }
      );
    },

    getExameCenterList() {
      const that = this;

      that.$api.get(
          "/api/qcxj/applyListDanweiPc",
          that.params,
          res => {
            that.loading = false;

            res.data.p = parseInt(res.data.p)
            res.data.step = parseInt(res.data.step)
            res.data.total = parseInt(res.data.total)
            that.row = res.data
            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.list = res.data.list;
            } else {
              that.list = that.list.concat(res.data.list);
            }
            if (res.data.list.length == 0) {
              that.finished = true;
            }

            that.params.pageNo += 1;
          },
          res => {
            that.$message.error(res.msg);
          }
      );
    },

    getKaojiMemberList() {
      const that = this;

      that.$api.get(
          "/api/qcxj/applyMemberListPc",
          that.params,
          res => {
            that.loading = false;

            res.data.p = parseInt(res.data.p)
            res.data.step = parseInt(res.data.step)
            res.data.total = parseInt(res.data.total)
            that.row = res.data
            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.list = res.data.list;
            } else {
              that.list = that.list.concat(res.data.list);
            }
            if (res.data.list.length == 0) {
              that.finished = true;
            }

            that.params.pageNo += 1;
          },
          res => {
            that.$message.error(res.msg);
          }
      );
    },

    getClubList() {
      const that = this;

      that.$api.get(
          "/api/club/clubList",
          that.params,
          res => {
            that.loading = false;

            res.data.p = parseInt(res.data.p)
            res.data.step = parseInt(res.data.step)
            res.data.total = parseInt(res.data.total)
            that.row = res.data
            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.list = res.data.list;
            } else {
              that.list = that.list.concat(res.data.list);
            }
            if (res.data.list.length == 0) {
              that.finished = true;
            }

            that.params.pageNo += 1;
          },
          res => {
            that.$message.error(res.msg);
          }
      );
    },

    getSihaoList() {
      const that = this;

      that.$api.get(
          "/api/csihao/sihaoMemberList",
          that.params,
          res => {
            that.loading = false;

            res.data.p = parseInt(res.data.p)
            res.data.step = parseInt(res.data.step)
            res.data.total = parseInt(res.data.total)
            that.row = res.data
            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.list = res.data.list;
            } else {
              that.list = that.list.concat(res.data.list);
            }
            if (res.data.list.length == 0) {
              that.finished = true;
            }

            that.params.pageNo += 1;
          },
          res => {
            that.$message.error(res.msg);
          }
      );
    },


    getDakejianList() {
      const that = this;

      that.$api.get(
          "/api/cdakejian/dakejianListPc",
          that.params,
          res => {
            that.loading = false;

            res.data.p = parseInt(res.data.p)
            res.data.step = parseInt(res.data.step)
            res.data.total = parseInt(res.data.total)
            that.row = res.data
            if (res.data.currentpage == 1) {
              that.isLoading = false;
              that.list = res.data.list;
            } else {
              that.list = that.list.concat(res.data.list);
            }
            if (res.data.list.length == 0) {
              that.finished = true;
            }

            that.params.pageNo += 1;
          },
          res => {
            that.$message.error(res.msg);
          }
      );
    },
    onSearch() {
      this.params.pageNo = 1
      this.getData()
    },

    getData() {
      this.list = []
      this.loading = true
      // this.params.namekey = 0
      // this.params.area_type = 0
      // this.getExameCenterList()
      // return
      /**
       * if(val == '星级俱乐部' || val == '四好运动员' || val == '七彩星级等级运动员' || val == '考级中心(点)') {
       * @type {string}
       */
      let name = this.activeSecondName
      switch (name) {
        case "星级俱乐部":
          this.getClubList()
          break;
        case "四好运动员":
          this.getSihaoList()
          break;
        case "大课间推广实施单位及先进个人":
          this.getDakejianList()
          break;
        case "七彩星级等级运动员":
          this.getKaojiMemberList()
          break;
        case "考级中心(点)":
          this.getExameCenterList()
          break;
      }
    },

    getSecondTabs() {
      this.tabListSecond = this.tabListSecondClub
    },

    onSelectArea(key) {
      this.params.pageNo = 1;
      this.list = []
      this.params.namekey = key

      console.log("this.params.namekey", this.params.namekey)

      this.loading = true;
      this.finished = false;
      this.getData();
    },

    onSelectType(id) {
      this.params.pageNo = 1;
      this.list = []
      this.params.area_type = id

      this.loading = true;
      this.finished = false;
      this.getData();
    },

    // 申报入口
    toApply() {
      let activeName = this.activeSecondName,
          name = ''
      switch (activeName) {
        case "星级俱乐部":
          name = 'ClubIndex'
          break;
        case "四好运动员":
          name = 'ClubDetailSihao'
          break;
        case "大课间推广实施单位及先进个人":
          name = 'DakejianApplySimple'
          break;
        case "考级中心(点)":
          name = 'ClubIndex'
          break;
        case "七彩星级等级运动员":
          name = 'ClubIndex'
          break;
        case "七彩文化区":

          break;
        case "风采展示":

          break;
      }

      rbLink({
        name: name
      })
    },

    onClick(record) {
      // console.log('onClick', record)
      this.params.pageNo = 1;
      this.activeName = record.name
      this.params.keywords = '';
      this.params.namekey = 0
      this.params.area_type = 0
      this.list = []
      this.loading = true
      this.finished = false

      // 判断第二级的目录显示
      let tabList = [],
          secondName = ''
      if (record.name == '啦啦操星级俱乐部') {
        tabList = this.tabListSecondClub
        secondName = "星级俱乐部"
      } else if (record.name == '啦啦操七彩星级') {
        tabList = this.tabListSecondQcxj
        secondName = "考级中心(点)"
      } else if (record.name == '政策解读') {
        this.params.pageNo = 1;
        this.params.cate_id = 98
        this.fetch()
      } else if (record.name == '宣传文件') {
        this.params.pageNo = 1;
        this.params.cate_id = 104
        this.fetch()
      }

      console.log(tabList, secondName)
      this.tabListSecond = tabList
      this.activeSecondName = secondName
    },

    onClickSecond(record) {
      console.log('onClick', record)
      if(record.name == this.activeSecondName) return

      this.activeSecondName = record.name

      this.params.pageNo = 1;
      this.params.keywords = '';
      this.params.namekey = 0
      this.params.area_type = 0
      this.list = []
      this.loading = true
      this.finished = false
      if (record.name == '风采展示') {
        this.params.cate_id = 99
        this.onRefreshData()
      } else if (record.name == '七彩文化区') {
        this.params.cate_id = 99
        this.onRefreshData()
      }
    },

    onRefreshData() {
      this.params.pageNo = 1;
      this.list = []
      this.fetch()
    },

    handleSizeChange(val) {
      this.list = []
      this.params.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.list = []
      this.params.pageNo = val;
      this.getData();
    },

    //处理video点击事件
    handlevideoAction() {
      this.videoAction = !this.videoAction;
      if (!this.videoAction && this.$refs.myVideo) {
        setTimeout(() => {
          this.$refs.myVideo.pause();
          this.$refs.myVideo.currentTime = 0;
        }, 600);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.businesscooperation_list {
  //margin-top: 73px;
  .businesscooperation_list_item_container {
    margin-right: 30px;
    margin-bottom: 31px;
    display: inline-block;
    font-size: 0;
    box-sizing: border-box;

    &:nth-child(3n) {
      margin-right: 0;
    }

    &:hover {
      cursor: pointer;

      .businesscooperation_list_item {
        box-shadow: 0px 10px 28px 0px rgb(155, 154, 154);
      }
    }

    .businesscooperation_list_item {
      width: 380px;
      //height: 501px;
      background: #ffffff;
      box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.06);
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding-bottom: 20px;

      img {
        // width: 379px;
        width: 100%;
        height: 267px;
        object-fit: cover;
      }

      .businesscooperation_list_item_title {
        //width: 100%;
        height: 32px;
        font-size: 22px;
        font-weight: 500;
        color: #000000;
        line-height: 32px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        //margin-top: 24px;
        //margin-left: 12px;
        margin: 24px 0 0 12px;
        box-sizing: border-box;
      }

      .businesscooperation_list_item_subtitle {
        width: 100%;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #444444;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 14px 0 0 12px;
        box-sizing: border-box;
      }

      .businesscooperation_list_item_tips {
        max-width: 100%;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        box-sizing: border-box;
        text-overflow: ellipsis;
        margin: 14px 0 0 12px;
      }

      /deep/ .el-divider--horizontal {
        margin: 10px 0 20px 0;
      }

      .businesscooperation_list_item_tags {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        box-sizing: border-box;

        .businesscooperation_list_item_tags_el {
          flex: 1;

          .businesscooperation_list_item_tags_el_num {
            height: 33px;
            font-size: 30px;
            font-weight: bold;
            color: #000000;
            line-height: 34px;
            text-align: center;
          }

          .businesscooperation_list_item_tags_el_font {
            height: 32px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 32px;
            text-align: center;
            margin-top: 3px;
          }
        }
      }
    }
  }
}

.culturalhistory {
  background: #f8f8f8;
  min-height: 1654px;
}

.banner_bg {
  position: relative;
  height: 500px;
  overflow: hidden;

  .banner_bg_pic {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    height: 500px;
    object-fit: cover;
    width: 100%;
    display: block;
  }

  .banner_bg_desc {
    position: relative;
    z-index: 1;
    width: 1200px;
    margin: 0 auto;
    margin-top: 44px;
    padding-left: 40px;
    box-sizing: border-box;

    .banner_bg_desc_title {
      height: 70px;
      font-size: 46px;
      font-weight: 600;
      color: #ffffff;
      line-height: 70px;
    }

    .banner_bg_desc_entitle {
      height: 42px;
      font-size: 20px;
      // font-weight: 600;
      color: #ffffff;
      line-height: 42px;
    }
  }

  .banner_videoplay_icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
    width: 120px;
    height: 120px;
    object-fit: cover;

    &:hover {
      cursor: pointer;
      opacity: 0.9;
    }
  }

  video {
    height: 100%;
    width: 100%;
    object-fit: contain;
    // position: relative;
    // z-index: 0;
  }
}

.contactus_content {
  width: 1200px;
  min-height: 803px;
  //background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;
  //padding: 47px 103px 40px 36px;
  margin: 0 auto;
  //padding-bottom: 40px;

  .header_screen {
    width: 1200px;
    //height: 132px;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    margin-bottom: 30px;
    margin-top: -18px;
    position: relative;
    box-sizing: border-box;
    padding: 30px 0 20px 24px;

    .header_screen_item {
      display: flex;
      flex-direction: row;
      //align-items: center;
      //height: 40px;
      cursor: default;

      .header_screen_item_title {
        height: 20px;
        min-width: 42px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-right: 41px;
      }

      .header_screen_item_el {
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        margin-right: 41px;
        margin-bottom: 10px;
        float: left;

        &:hover {
          cursor: pointer;
          color: #f56057;
        }
      }

      .header_screen_item_el_active {
        color: #f56057;
      }
    }
  }

  .contactus_content_up {
    box-sizing: border-box;
    min-height: 558px;
  }

  .contactus_content_but {
    width: 260px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: linear-gradient(124deg, #fec835 0%, #ffad19 100%);
    border-radius: 77px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: 400;
    color: #ffffff;

    &:hover {
      opacity: 0.89;
      cursor: pointer;
    }
  }
}

.organization_content {
  .header_screen {
    //width: 1200px;
    //height: 132px;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    margin-bottom: 30px;
    margin-top: 10px;
    position: relative;
    box-sizing: border-box;
    padding: 30px 0 20px 24px;

    .header_screen_item {
      display: flex;
      flex-direction: row;
      //align-items: center;
      //height: 40px;
      cursor: default;

      .header_screen_item_title {
        height: 20px;
        min-width: 42px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-right: 41px;
      }

      .header_screen_item_el {
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        margin-right: 41px;
        margin-bottom: 10px;
        float: left;

        &:hover {
          cursor: pointer;
          color: #f56057;
        }
      }

      .header_screen_item_el_active {
        color: #f56057;
      }
    }
  }

  .organization_content_list {
    font-size: 0;

    .organization_content_list_item {
      width: 355px;
      height: 140px;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
      border-radius: 10px;
      display: inline-flex;
      flex-direction: row;
      padding: 16px 0 0 16px;
      margin-right: 30px;
      margin-bottom: 30px;
      box-sizing: border-box;
      position: relative;
      transition: all 0.4s;

      &:nth-child(3n) {
        margin-right: 0;
      }

      &:hover {
        cursor: pointer;
        transform: scale(1.03);
      }

      .organization_content_list_item_left {
        text-align: center;
        margin-right: 16px;

        .el-image {
          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          width: 90px;
          height: 90px;
          border-radius: 3px;
        }

        .organization_content_list_item_tip {
          margin-top: 5px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
      }

      .organization_content_list_item_desc {
        flex: 1;

        .organization_content_list_item_desc_tip {
          font-size: 14px;
          width: 230px;
        }

        .organization_content_list_item_title {
          font-size: 16px;
          font-weight: 500;
          width: 230px;
        }

        .organization_content_list_item_nopic_title {
          font-size: 16px;
          font-weight: 500;
          width: 300px;
        }

        .organization_content_list_item_desc_title {
          height: 32px;
          font-size: 22px;
          font-weight: 500;
          color: #000000;
          line-height: 32px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 7px;

          width: 260px;
        }

        .organization_content_list_item_desc_contacts {
          font-size: 14px;
          font-weight: 400;
          color: #444444;
          width: 300px;
          line-height: 24px;
        }
      }

      .organization_content_list_item_tag_province {
        width: 75px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        background: linear-gradient(133deg, #FA6400 0%, #FD9D00 100%);
        border-radius: 10px 0px 10px 10px;
        position: absolute;
        bottom: 0;
        right: 0;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
      }

      .organization_content_list_item_tag {
        width: 75px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        background: linear-gradient(130deg, #7798FF 0%, #D4E1FF 100%);;
        border-radius: 10px 0px 10px 10px;
        position: absolute;
        bottom: 0;
        right: 0;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// QcxjClub.vue?48c63418